import * as types from "../actions/types";

const INITIAL_STATE = {
  redirect_links: null,
  redirect_links_loading: false,
  redirect_links_soft_loading: false
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.FETCH_ALL_REDIRECT_LINKS_LOADING:
      return { ...state, redirect_links_loading: true };
    case types.FETCH_ALL_REDIRECT_LINKS_SOFT_LOADING:
      return { ...state, redirect_links_soft_loading: true };
    case types.FETCH_ALL_REDIRECT_LINKS_SUCCESS:
      return {
        ...state,
        redirect_links: action.payload,
        redirect_links_loading: false,
        redirect_links_soft_loading: false
      };

    default:
      return state;
  }
}
